import Frame from './Frame.svelte';

const frame = new Frame({
	target: document.body
});

export default frame;
